import * as actionTypes from '../actions/actionTypes';

const listMutations = {
  [actionTypes.LIST_USERS_START](state) {
    state.users = [];
    state.isUsersLoading = true;
  },
  [actionTypes.LIST_USERS_SUCCESS](state, payload) {
    state.isUsersLoading = false;
    state.users = payload;
  },
  [actionTypes.LIST_USERS_FAIL](state, payload) {
    state.isUsersLoading = false;
    state.userError = payload;
  },
};

const createMutations = {
  [actionTypes.CREATE_USER_START](state) {
    state.isUsersLoading = true;
  },
  [actionTypes.CREATE_USER_SUCCESS](state) {
    state.isUsersLoading = false;
  },
  [actionTypes.CREATE_USER_FAIL](state, payload) {
    state.isUsersLoading = false;
    state.userError = payload;
  },
};

const updateMutations = {
  [actionTypes.UPDATE_USER_START](state) {
    state.isUsersLoading = true;
  },
  [actionTypes.UPDATE_USER_SUCCESS](state) {
    state.isUsersLoading = false;
    state.userToUpdate = null;
  },
  [actionTypes.UPDATE_USER_FAIL](state, payload) {
    state.isUsersLoading = false;
    state.userError = payload;
  },
};

const deleteMutations = {
  [actionTypes.DELETE_USER_START](state) {
    state.isUsersLoading = true;
  },
  [actionTypes.DELETE_USER_SUCCESS](state) {
    state.isUsersLoading = false;
    state.userToDelete = null;
  },
  [actionTypes.DELETE_USER_FAIL](state, payload) {
    state.isUsersLoading = false;
    state.userError = payload;
  },
};

const setUserToUpdateMutation = {
  [actionTypes.SET_USER_TO_UPDATE](state, payload) {
    state.userToUpdate = payload;
  },
};

const setUserToDeleteMutation = {
  [actionTypes.SET_USER_TO_DELETE](state, payload) {
    state.userToDelete = payload;
  },
};

const clearUserUpdateMutation = {
  [actionTypes.CLEAR_USER_UPDATE_STATE](state) {
    state.userToUpdate = null;
    state.userError = null;
  },
};

const mutations = {
  ...listMutations,
  ...createMutations,
  ...updateMutations,
  ...deleteMutations,
  ...setUserToUpdateMutation,
  ...setUserToDeleteMutation,
  ...clearUserUpdateMutation,
};


export default mutations;
